/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRelease = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a1 1 0 0 1 .889.542l1.679 3.259 3.491-1.117a1 1 0 0 1 1.257 1.257L18.2 9.432l3.259 1.679a1 1 0 0 1 0 1.778L18.2 14.568l1.117 3.491a1 1 0 0 1-1.257 1.257L14.568 18.2l-1.679 3.259a1 1 0 0 1-1.778 0L9.432 18.2l-3.491 1.117a1 1 0 0 1-1.257-1.257L5.8 14.568l-3.259-1.679a1 1 0 0 1 0-1.778L5.8 9.432 4.683 5.941A1 1 0 0 1 5.94 4.684L9.432 5.8l1.679-3.259A1 1 0 0 1 12 2zm0 3.183L10.822 7.47a1 1 0 0 1-1.193.494L7.18 7.18l.783 2.449a1 1 0 0 1-.494 1.194L5.183 12l2.286 1.178a1 1 0 0 1 .494 1.193L7.18 16.82l2.449-.784a1 1 0 0 1 1.194.495L12 18.817l1.178-2.286a1 1 0 0 1 1.193-.494l2.449.783-.784-2.449a1 1 0 0 1 .495-1.194L18.817 12l-2.286-1.178a1 1 0 0 1-.494-1.193l.783-2.449-2.449.783a1 1 0 0 1-1.194-.494L12 5.183z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRelease as Release };
